export function Building({
  position = [0, 0, 0],
  scale = 1,
}: {
  position: [number, number, number];
  scale?: number;
}) {
  const buildingColor = '#E3F2FD';
  const roofColor = '#F44336';

  return (
    <group position={position} scale={scale}>
      {/* Main building structure */}
      <mesh position={[0, 1.5, 0]} castShadow>
        <boxGeometry args={[4, 3, 4]} />
        <meshLambertMaterial color={buildingColor} flatShading />
      </mesh>

      {/* Roof */}
      <mesh position={[0, 3.5, 0]} castShadow>
        <coneGeometry args={[3, 2, 4]} />
        <meshLambertMaterial color={roofColor} flatShading />
      </mesh>

      {/* Door */}
      <mesh position={[0, 0.75, 2.01]} castShadow>
        <boxGeometry args={[1, 1.5, 0.1]} />
        <meshLambertMaterial color="#795548" flatShading />
      </mesh>

      {/* Windows */}
      <mesh position={[-1.5, 1.5, 2.01]} castShadow>
        <boxGeometry args={[0.8, 0.8, 0.1]} />
        <meshLambertMaterial color="#B3E5FC" flatShading />
      </mesh>

      <mesh position={[1.5, 1.5, 2.01]} castShadow>
        <boxGeometry args={[0.8, 0.8, 0.1]} />
        <meshLambertMaterial color="#B3E5FC" flatShading />
      </mesh>

      {/* Side Windows */}
      <mesh position={[2.01, 1.5, 0]} castShadow>
        <boxGeometry args={[0.1, 0.8, 0.8]} />
        <meshLambertMaterial color="#B3E5FC" flatShading />
      </mesh>

      <mesh position={[-2.01, 1.5, 0]} castShadow>
        <boxGeometry args={[0.1, 0.8, 0.8]} />
        <meshLambertMaterial color="#B3E5FC" flatShading />
      </mesh>
    </group>
  );
}
